"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var html_react_parser_1 = __importStar(require("html-react-parser"));
var IMAGE_ID_ATTRIBUTE_IDENTIFIER = 'data-image-id';
var LINKED_ITEM_ID_ATTRIBUTE_IDENTIFIER = 'data-item-id';
// Use custom guard instead of the `instanceof` check because it seems to be broken now (see https://github.com/remarkablemark/html-react-parser/issues/633)
var isElement = function (domNode) {
    return domNode.type === 'tag';
};
var isLinkedItem = function (domNode) {
    var _a;
    return isElement(domNode) &&
        domNode.tagName === 'object' &&
        ((_a = domNode.attributes.find(function (attr) { return attr.name === 'type'; })) === null || _a === void 0 ? void 0 : _a.value) === 'application/kenticocloud';
};
var isImage = function (domNode) {
    var _a;
    return isElement(domNode) &&
        domNode.tagName === 'figure' &&
        ((_a = domNode.attributes.find(function (attr) { return attr.name === IMAGE_ID_ATTRIBUTE_IDENTIFIER; })) === null || _a === void 0 ? void 0 : _a.value) !== 'undefined';
};
var isLinkedItemLink = function (domNode) {
    var _a;
    return isElement(domNode) &&
        domNode.tagName === 'a' &&
        ((_a = domNode.attributes.find(function (attr) { return attr.name === LINKED_ITEM_ID_ATTRIBUTE_IDENTIFIER; })) === null || _a === void 0 ? void 0 : _a.value) !== 'undefined';
};
var replaceNode = function (domNode, richTextElement, resolveLinkedItem, resolveImage, resolveLink, resolveDomNode) {
    var _a, _b, _c;
    var images = richTextElement.images, links = richTextElement.links;
    if (resolveLinkedItem && richTextElement.linkedItems) {
        if (isLinkedItem(domNode)) {
            var node = domNode;
            var codeName_1 = (_a = node === null || node === void 0 ? void 0 : node.attributes.find(function (attr) { return attr.name === 'data-codename'; })) === null || _a === void 0 ? void 0 : _a.value;
            var linkedItem = codeName_1 ? richTextElement.linkedItems.find(function (item) { return item.system.codename === codeName_1; })
                : undefined;
            return resolveLinkedItem(linkedItem, { domElement: node, domToReact: html_react_parser_1.domToReact });
        }
    }
    if (resolveImage && images) {
        if (isImage(domNode)) {
            var node = domNode;
            var imageId_1 = (_b = node === null || node === void 0 ? void 0 : node.attributes.find(function (attr) { return attr.name === IMAGE_ID_ATTRIBUTE_IDENTIFIER; })) === null || _b === void 0 ? void 0 : _b.value;
            var image = images.find(function (image) { return image.imageId === imageId_1; });
            if (image) {
                return resolveImage(image, { domElement: node, domToReact: html_react_parser_1.domToReact });
            }
        }
    }
    if (resolveLink && links) {
        if (isLinkedItemLink(domNode)) {
            var node = domNode;
            var linkId_1 = (_c = node === null || node === void 0 ? void 0 : node.attributes.find(function (attr) { return attr.name === LINKED_ITEM_ID_ATTRIBUTE_IDENTIFIER; })) === null || _c === void 0 ? void 0 : _c.value;
            var link = links.find(function (link) { return link.linkId === linkId_1; });
            if (link) {
                return resolveLink(link, { domElement: node, domToReact: html_react_parser_1.domToReact });
            }
        }
    }
    if (resolveDomNode) {
        return resolveDomNode({ domNode: domNode, domToReact: html_react_parser_1.domToReact });
    }
};
var RichTextElement = function (_a) {
    var richTextElement = _a.richTextElement, resolvers = _a.resolvers;
    // To avoid type error in case resolvers is undefined
    var _b = __assign({}, resolvers), resolveLinkedItem = _b.resolveLinkedItem, resolveImage = _b.resolveImage, resolveLink = _b.resolveLink, resolveDomNode = _b.resolveDomNode;
    var cleanedValue = richTextElement.value.replace(/(\n|\r)+/, '');
    var result = (0, html_react_parser_1.default)(cleanedValue, {
        replace: function (domNode) { return replaceNode(domNode, richTextElement, resolveLinkedItem, resolveImage, resolveLink, resolveDomNode); },
    });
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: result });
};
exports.RichTextElement = RichTextElement;
